// Shared primitives for TTS UI widgets — kept here so the voice picker,
// upsell modal, chat container, and reader settings all render identical
// rate options, play icons, and gender labels.

import * as preact from "preact";

export const RATE_CHOICES = [0.6, 0.8, 0.9, 1, 1.2, 1.5];

export const playIcon = (): preact.JSX.Element => (
  <svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true">
    <polygon points="2.4,1.2 8.6,5 2.4,8.8" fill="currentColor" />
  </svg>
);

export const capitalizeGender = (
  gender?: "male" | "female"
): string | undefined => {
  if (!gender) return undefined;
  return gender === "male" ? "Male" : "Female";
};
